import React from 'react'
// import moreOptionIcon from '../../../../_metronic/assets/images/svg/data-room/more-options-icon.svg'
// import OutsideClickHandler from 'react-outside-click-handler'
// import SpaceFileDropdown from '../components/SpaceFileDropdown'
import activeFolderLargeIcon from '../../../../_metronic/assets/images/svg/data-room/blue-folder-large-icon.svg'
// import { toast } from 'react-toastify'
// import { updateIsHiddenToggle } from '../core/_requests';
import { DateTime } from 'luxon'
import { ContentTypes } from '../core/_constants'
import { toAbsoluteUrl } from '../../../../_metronic/helpers/index'
import { useIntl } from 'react-intl'
// import { ContentTypes } from '../core/_constants'

const EditSpaceFileRow = ({
  data,
  handleClick,
  index,
  getDataRoomContentByparentId,
  getDataRoomContentById,
}: any) => {
  // const [isHiddenToggle, setIsHiddenToggle] = useState<boolean>(data?.dataRooms[0]?.dataroom_content.isHidden)
  // const [, setisHiddenToggleChangesLoading] = useState<boolean>()
  // const [menuOpen, setMenuOpen] = useState<any>(null)
  // const [renameModalContentIdTwo,] = useState<number | null>(null)
  const { formatMessage } = useIntl()

  function getTimeDifference(date: any) {
    const minutes = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject()
          .minutes
      )
    )

    const days = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().days
      )
    )

    const hours = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().hours
      )
    )
    if (days === 0 && hours === 0) {
      return `${minutes} ${formatMessage({ id: 'min ago' })}`
    }
    if (days === 0) {
      return `${hours} ${formatMessage({ id: 'hrs ago' })}`
    } else if (days === 7) {
      return `${formatMessage({ id: '1 week' })}`
    } else if (days < 7) {
      return `${days} ${formatMessage({ id: 'days ago' })}`
    } else {
      return DateTime.fromISO(date).toFormat('MMM dd')
    }
  }

  const handleItemClick = () => {
    handleClick(
      index,
      data?.dataroom_content?.dataroom_contentId,
      data?.type,
      data?.file?.name,
      data?.name,
      data?.contentId
    )
    // setDataRoomLatestBreadcrumbId(data?.dataroom_content?.dataroom_contentId)
  }

  // const isHiddenToggleChanges = async (isHiddenToggle: boolean) => {
  //   try {
  //     setisHiddenToggleChangesLoading(true)
  //     if (data?.contentId) {
  //       const {
  //         data: { success, errors },
  //       } = await updateIsHiddenToggle(data?.contentId, data?.dataRooms[0]?.dataRoomId, isHiddenToggle);
  //       if (success) {
  //         getDataRoomContentByparentId()
  //         toast.success(formatMessage({ id: 'Hidden successfully' }));
  //       } else {
  //         errors.forEach((error: string) => {
  //           toast.error(formatMessage({ id: error }))
  //         })
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err)
  //   }
  //   finally {
  //     setisHiddenToggleChangesLoading(false)
  //   }
  // }

  // const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const newIsHidden = event.target.checked;
  //   setIsHiddenToggle(newIsHidden);
  //   isHiddenToggleChanges(newIsHidden)
  // };

  return (
    <>
      <div
        key={index}
        className='file-nav-list d-flex flex-row align-items-center justify-content-between dark-border'
      >
        <div
          className=' d-flex flex-row align-items-center file-nav-list-left'
          onClick={handleItemClick}
        >
          <div className='file-image-wrapper d-flex justify-content-center'>
            {data?.type === ContentTypes.FOLDER ? (
              <img src={activeFolderLargeIcon} alt='folder-icon' />
            ) : (
              <>
                {data && data?.file?.name.split('.').pop() === 'pdf' && (
                  <img
                    height={40}
                    width={40}
                    alt='pdf'
                    className='pe-2'
                    src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                  />
                )}
                {data &&
                  (data?.file?.name.split('.').pop() === 'docx' ||
                    data?.file?.name.split('.').pop() === 'doc') && (
                    <img
                      height={40}
                      width={40}
                      alt='docx'
                      className='pe-2'
                      src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                    />
                  )}
                {data &&
                  (data?.file?.name.split('.').pop() === 'pptx' ||
                    data?.file?.name.split('.').pop() === 'ppt') && (
                    <img
                      height={40}
                      width={40}
                      alt='pptx'
                      className='pe-2'
                      src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                    />
                  )}
                {data &&
                  (data?.file?.name.split('.').pop() === 'jpg' ||
                    data?.file?.name.split('.').pop() === 'png' ||
                    data?.file?.name.split('.').pop() === 'jpeg') && (
                    <img
                      height={40}
                      width={40}
                      alt='blank'
                      className='pe-2'
                      src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                    />
                  )}
                {data && data?.file?.name.split('.').pop() === 'xlsx' && (
                  <img
                    height={40}
                    width={40}
                    alt='blank'
                    className='pe-2'
                    src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                  />
                )}
                {data &&
                  !(
                    data?.file?.name.split('.').pop() === 'pdf' ||
                    data?.file?.name.split('.').pop() === 'docx' ||
                    data?.file?.name.split('.').pop() === 'doc' ||
                    data?.file?.name.split('.').pop() === 'pptx' ||
                    data?.file?.name.split('.').pop() === 'ppt' ||
                    data?.file?.name.split('.').pop() === 'jpg' ||
                    data?.file?.name.split('.').pop() === 'png' ||
                    data?.file?.name.split('.').pop() === 'jpeg' ||
                    data?.file?.name.split('.').pop() === 'xlsx'
                  ) && (
                    <img
                      height={40}
                      width={40}
                      alt='blank'
                      className='pe-2'
                      src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                    />
                  )}
              </>
            )}
          </div>

          <div className=''>
            <p className='mb-0 font-size-14 text-dark'>
              {data?.file?.fileName}
            </p>
            <p className='mb-0 file-update-status text-muted font-size-12'>
              {formatMessage({ id: 'Updated' })} {getTimeDifference(data?.updatedAt)}
            </p>
          </div>
        </div>
        <div className='d-md-flex flex-row align-items-center file-nav-list-right  d-none'>
          {/* <label className='toggle' htmlFor={`${data.contentId}`}>
          <input className='toggle__input'
            name=''
            type='checkbox'
            id={`${data.contentId}`}
            checked={isHiddenToggle}
            onChange={handleToggleChange}
          />
          <div className='toggle__fill'></div>
        </label> */}

          {/* ADD MORE FILES OPTION IN CHILD CODE BELOW*/}

          {/* {data.type===ContentTypes.FOLDER && <div className='file-nav-list-options'>
          
            <button
              type='button'
              className='btn btn-sm card-option btn-icon btn-color-primary btn-active-light-primary'
              onClick={() =>{ setMenuOpen(menuOpen !== data.contentId ? data.contentId : null);setOneDropdownOpenBool(true)}}
            >
              <img src={moreOptionIcon} alt='more-option-icon'></img>
            </button>
            {renameModalContentIdTwo ? (
                   <OutsideClickHandler onOutsideClick={() => setMenuOpen(null)}>
            <SpaceFileDropdown
              isOpen={(menuOpen === data?.contentId) && oneDropdownOpenBool}
              contentId={data?.contentId}
              parentId={data?.parentId}
              type={data.type}
              name={data.name}
              getDataRoomContentById ={ getDataRoomContentById}
              getDataRoomContentByparentId={getDataRoomContentByparentId}
              setMenuOpen={setMenuOpen}
              addFilesBool={true}
            />
          </OutsideClickHandler>):(<SpaceFileDropdown
              isOpen={(menuOpen === data?.contentId) && oneDropdownOpenBool}
              contentId={data?.contentId}
              parentId={data?.parentId}
              type={data.type}
              name={data.name}
              getDataRoomContentById ={ getDataRoomContentById}
              getDataRoomContentByparentId={getDataRoomContentByparentId}
              setMenuOpen={setMenuOpen}
              addFilesBool={true}
            />)}
        </div>} */}
        </div>
      </div>
    </>
  )
}

export default EditSpaceFileRow
